/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "PaymentDetail": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.PaymentDetail) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE PaymentDetail @ squareup/solidshop/model/payment_detail.proto at 8:1
 */
export const PaymentDetail = $root.lookupType('squareup.solidshop.model.PaymentDetail');
fixType(PaymentDetail);
Builder.createAndAttachToType(PaymentDetail);
